import produce from 'immer'
import { SeccionsociosAction, SeccionsociosActionTypes } from '../actions/seccionsociosActions'
import { ApiStatus, ISeccionsociosItem } from '../models'

export const initialSeccionsociosState: ISeccionsociosState = {
  loadingStatus: ApiStatus.NOTLOADED,
  addingStatus: ApiStatus.NOTLOADED,
  searchingStatus: ApiStatus.NOTLOADED,
  searchString: '',
  seccionsocios: [],
  foundseccionsocios: [],
  totalDocs: 0,
  errMessage: '',
  errStatus: null,
  errField: null,
}

export default function seccionsociosReducer(state: ISeccionsociosState = initialSeccionsociosState, action: SeccionsociosAction) {
  return produce(state, (draft) => {
    switch (action.type) {
      case SeccionsociosActionTypes.SEARCH_SECCIONSOCIOS:
        draft.searchString = action.searchOptions.searchString
        break
      case SeccionsociosActionTypes.SEARCHING_SECCIONSOCIOS:
        draft.searchingStatus = ApiStatus.LOADING
        draft.loadingStatus = ApiStatus.NOTLOADED
        draft.addingStatus = ApiStatus.NOTLOADED
        break

      case SeccionsociosActionTypes.SEARCHING_SECCIONSOCIOS_FAILED:
        draft.searchingStatus = ApiStatus.FAILED
        break

      case SeccionsociosActionTypes.FOUND_SECCIONSOCIOS:
        draft.searchingStatus = ApiStatus.LOADED
        action.keep
          ? draft.foundseccionsocios.push(...action.payload.seccionsocios.docs)
          : (draft.foundseccionsocios = action.payload.seccionsocios.docs)
        draft.totalDocs = action.payload.seccionsocios.totalDocs
        break

      case SeccionsociosActionTypes.LOAD_SECCIONSOCIOS:
      case SeccionsociosActionTypes.LOADING_SECCIONSOCIOS:
        draft.loadingStatus = ApiStatus.LOADING
        draft.addingStatus = ApiStatus.NOTLOADED
        draft.searchingStatus = ApiStatus.NOTLOADED
        draft.foundseccionsocios = []
        break

      case SeccionsociosActionTypes.LOADING_SECCIONSOCIOS_FAILED:
        draft.loadingStatus = ApiStatus.FAILED
        break

      case SeccionsociosActionTypes.LOADED_SECCIONSOCIOS:
        draft.loadingStatus = ApiStatus.LOADED
        draft.seccionsocios = action.payload.seccionsocios.docs
        draft.totalDocs = action.payload.seccionsocios.totalDocs
        break

      case SeccionsociosActionTypes.ADD_SECCIONSOCIOS:
      case SeccionsociosActionTypes.ADDING_SECCIONSOCIOS:
        draft.addingStatus = ApiStatus.LOADING
        draft.searchingStatus = ApiStatus.NOTLOADED
        draft.errMessage = ''
        draft.errStatus = null
        draft.errField = null
        break

      case SeccionsociosActionTypes.ADDING_SECCIONSOCIOS_FAILED:
        draft.addingStatus = ApiStatus.FAILED
        draft.errMessage = action.message
        draft.errStatus = action.status
        draft.errField = action.field
        break

      case SeccionsociosActionTypes.ADDED_SECCIONSOCIOS:
        draft.addingStatus = ApiStatus.LOADED
        draft.errStatus = 200
        draft.seccionsocios.push(action.payload.seccionsocios.docs[0])
        if (draft.searchString) draft.foundseccionsocios.push(action.payload.seccionsocios.docs[0])
        break

      case SeccionsociosActionTypes.REMOVE_SECCIONSOCIO:
        draft.seccionsocios.splice(
          draft.seccionsocios.findIndex((seccionsocio) => seccionsocio._id === action.payload._id),
          1
        )
        break

      case SeccionsociosActionTypes.SOFT_REMOVE_SECCIONSOCIOS:
        draft.loadingStatus = ApiStatus.NOTLOADED
        draft.addingStatus = ApiStatus.LOADING
        break

      case SeccionsociosActionTypes.SOFT_REMOVING_SECCIONSOCIOS:
        draft.loadingStatus = ApiStatus.LOADING
        draft.addingStatus = ApiStatus.LOADING
        break

      case SeccionsociosActionTypes.SOFT_REMOVED_SECCIONSOCIOS:
        draft.addingStatus = ApiStatus.LOADED
        draft.seccionsocios.splice(
          draft.seccionsocios.findIndex((seccionsocio) => seccionsocio._id === action.payload._id),
          1
        )
        break

      case SeccionsociosActionTypes.SOFT_REMOVING_SECCIONSOCIOS_FAILED:
        draft.addingStatus = ApiStatus.FAILED
        draft.errMessage = action.message
        draft.errStatus = action.status
        draft.errField = action.field
        break

      case SeccionsociosActionTypes.EDIT_SECCIONSOCIOS:
        draft.loadingStatus = ApiStatus.NOTLOADED
        draft.addingStatus = ApiStatus.LOADING
        draft.searchingStatus = ApiStatus.NOTLOADED
        break

      case SeccionsociosActionTypes.EDITING_SECCIONSOCIOS:
        draft.loadingStatus = ApiStatus.LOADING
        draft.addingStatus = ApiStatus.LOADING
        break

      case SeccionsociosActionTypes.EDITED_SECCIONSOCIOS:
        draft.addingStatus = ApiStatus.LOADED
        draft.seccionsocios[draft.seccionsocios.findIndex((seccionsocio) => seccionsocio._id === action.payload._id)] = action.payload
        draft.foundseccionsocios[draft.foundseccionsocios.findIndex((seccionsocio) => seccionsocio._id === action.payload._id)] = action.payload
        break

      case SeccionsociosActionTypes.EDITING_SECCIONSOCIOS_FAILED:
        draft.addingStatus = ApiStatus.FAILED
        draft.errMessage = action.message
        draft.errStatus = action.status
        draft.errField = action.field
        break
    }
  })
}

export interface ISeccionsociosState {
  loadingStatus: ApiStatus
  addingStatus: ApiStatus
  searchingStatus: ApiStatus
  searchString: string
  seccionsocios: ISeccionsociosItem[]
  foundseccionsocios: ISeccionsociosItem[]
  totalDocs: number
  errMessage?: string
  errStatus?: number
  errField?: string
}
